(function () {
  /* =================================================
     CONFIG FROM LIQUID
  ================================================= */
  const TIERS = (BYO_CONFIG.tiers || []).slice().sort((a, b) => a - b);
  const DISCOUNTS = BYO_CONFIG.discounts || {};

  /* =================================================
     FREE SHIPPING CONFIG (CUSTOMIZABLE)
  ================================================= */
  const FREE_SHIPPING_THRESHOLD = Number(BYO_CONFIG.freeShippingThreshold || 50);

  // Supported placeholders: [amount] [threshold] [total]
  const FREE_SHIP_BEFORE_TEXT =
    BYO_CONFIG.freeShippingBeforeText || 'Add [amount] more to get FREE SHIPPING!';
  const FREE_SHIP_AFTER_TEXT =
    BYO_CONFIG.freeShippingAfterText || "You’ve unlocked FREE SHIPPING!";

  /* =================================================
     STATE
  ================================================= */
  const state = {
    items: [],
    maxSlots: Math.max(...TIERS),
    purchaseType: 'onetime'
  };

  const VALID_TIERS = TIERS;
  let els = {};

  /* =================================================
     MONEY HELPERS (SHOPIFY SAFE)
  ================================================= */
  function roundToCents(value) {
    return Math.floor((value + 1e-8) * 100) / 100;
  }

  function formatMoney(value) {
    return `$${roundToCents(value).toFixed(2)}`;
  }

  /* =================================================
     FREE SHIPPING HELPERS
  ================================================= */
  function replaceAllPlaceholders(text, map) {
    return String(text).replace(/\[(amount|threshold|total)\]/g, (m, key) => {
      return map[key] ?? m;
    });
  }

  function updateFreeShippingText(summary, currentTotal) {
    const el = summary.querySelector('.js-free-ship');
    if (!el) return;

    const remaining = roundToCents(
      Math.max(FREE_SHIPPING_THRESHOLD - currentTotal, 0)
    );

    const tokens = {
      amount: formatMoney(remaining),
      threshold: formatMoney(FREE_SHIPPING_THRESHOLD),
      total: formatMoney(currentTotal)
    };

    if (remaining > 0) {
      el.textContent = replaceAllPlaceholders(FREE_SHIP_BEFORE_TEXT, tokens);
    } else {
      el.textContent = replaceAllPlaceholders(FREE_SHIP_AFTER_TEXT, tokens);
    }
  }

  /* =================================================
     INIT
  ================================================= */
  function init() {
    cache();
    bind();
    updateUI();
  }

  /* =================================================
     CACHE DOM
  ================================================= */
  function cache() {
    els = {
      addBtns: document.querySelectorAll('.byo-add-btn'),
      filterTabs: document.querySelectorAll('.byo-filter-tab'),
      productCards: document.querySelectorAll('.byo-product-card'),

      summaries: document.querySelectorAll('.byo-summary, .byo-mobile-summary-body'),
      counts: document.querySelectorAll('.byo-count'),
      progressBars: document.querySelectorAll('.js-progress-fill'),

      purchaseCards: document.querySelectorAll('.byo-purchase-card'),
      checkoutBtns: document.querySelectorAll('.byo-checkout'),
      errorMsgs: document.querySelectorAll('.byo-error-message'),

      mobileHeader: document.querySelector('.byo-mobile-header'),
      mobileSticky: document.querySelector('.byo-mobile-sticky'),
      mobileBody: document.querySelector('.byo-mobile-summary-body')
    };
  }

  /* =================================================
     EVENTS
  ================================================= */
  function bind() {
    /* ADD PRODUCT */
    els.addBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('is-disabled')) return;
        if (state.items.length >= state.maxSlots) return;

        state.items.push({
          id: btn.dataset.id,
          price: parseFloat(btn.dataset.price || 0),
          image: btn.dataset.image,
          sellingPlan: btn.dataset.sellingPlan || null
        });

        btn.textContent = 'ADDED';
        btn.classList.add('is-added');

        setTimeout(() => {
          btn.textContent = '+ ADD';
          btn.classList.remove('is-added');
        }, 800);

        updateUI();
      });
    });

    /* FILTER TABS */
    els.filterTabs.forEach(tab => {
      tab.addEventListener('click', () => {
        els.filterTabs.forEach(t => t.classList.remove('is-active'));
        tab.classList.add('is-active');

        els.productCards.forEach(card => {
          card.style.display =
            card.dataset.collection === tab.dataset.collection ? '' : 'none';
        });
      });
    });

    /* PURCHASE TYPE */
    els.purchaseCards.forEach(card => {
      card.addEventListener('click', () => {
        els.purchaseCards.forEach(c => c.classList.remove('is-active'));
        card.classList.add('is-active');
        state.purchaseType = card.dataset.value;
        updateUI();
      });
    });

    /* MOBILE STICKY */
    if (els.mobileHeader && els.mobileSticky) {
      els.mobileHeader.addEventListener('click', () => {
        els.mobileSticky.classList.toggle('is-open');
      });
    }

    if (els.mobileBody) {
      els.mobileBody.addEventListener('click', e => e.stopPropagation());
    }

    /* CHECKOUT */
    els.checkoutBtns.forEach(btn => {
      btn.addEventListener('click', handleCheckout);
    });
  }

  /* =================================================
     HELPERS
  ================================================= */
  function activateTier(summary, value) {
    summary.querySelectorAll('.byo-tier').forEach(tier => {
      tier.classList.toggle('active', Number(tier.dataset.tier) === value);
    });
  }

  /* =================================================
     UI UPDATE
  ================================================= */
  function updateUI() {
    const qty = state.items.length;
    const isValid = VALID_TIERS.includes(qty);

    /* COUNT */
    els.counts.forEach(el => {
      el.textContent =
        qty === 0
          ? BYO_CONFIG.zeroText
          : BYO_CONFIG.selectedText.replace('[count]', qty);
    });

    /* CHECKOUT STATE */
    els.checkoutBtns.forEach(btn => {
      btn.classList.toggle('is-disabled', !isValid);
    });

    /* ERROR */
    els.errorMsgs.forEach(msg => {
      msg.style.display = isValid ? 'none' : 'block';
    });

    /* PROGRESS */
    const percent = Math.min((qty / state.maxSlots) * 100, 100);
    els.progressBars.forEach(bar => {
      bar.style.width = percent + '%';
    });

    /* SUMMARY + PRICING */
    els.summaries.forEach(summary => {
      const slots = summary.querySelector('.byo-items');

      /* SLOTS */
      if (slots) {
        slots.innerHTML = '';
        for (let i = 0; i < state.maxSlots; i++) {
          const slot = document.createElement('div');
          slot.className = 'byo-item';

          if (state.items[i]) {
            slot.classList.add('filled');

            const img = document.createElement('img');
            img.src = state.items[i].image;
            img.loading = 'lazy';

            const removeBtn = document.createElement('span');
            removeBtn.className = 'byo-remove-item';
            removeBtn.innerHTML = '&times;';
            removeBtn.onclick = e => {
              e.stopPropagation();
              state.items.splice(i, 1);
              updateUI();
            };

            slot.append(img, removeBtn);
          }

          slots.appendChild(slot);
        }
      }

      /* ACTIVE TIER */
      let activeTier = null;
      let bundleDiscount = 0;

      VALID_TIERS.forEach(tier => {
        if (qty >= tier) {
          activeTier = tier;
          bundleDiscount = DISCOUNTS[tier] || 0;
        }
      });

      summary.querySelectorAll('.byo-tier').forEach(t => t.classList.remove('active'));
      if (activeTier) activateTier(summary, activeTier);

      /* =================================================
         SHOPIFY-ACCURATE PRICE CALCULATION
      ================================================= */

      // 1️⃣ Sum raw prices (NO per-item rounding)
      const baseTotal = state.items.reduce((total, item) => total + item.price, 0);

      // 2️⃣ Apply bundle discount ONCE
      const oneTimeRaw = baseTotal * (1 - bundleDiscount);

      // 3️⃣ Apply subscription discount (dynamic)
      const subscriptionDiscount = BYO_CONFIG.subscriptionDiscount || 0;
      const subscriptionRaw = baseTotal * (1 - subscriptionDiscount);

      // 4️⃣ Final rounding
      const oneTimePrice = roundToCents(oneTimeRaw);
      const subscriptionPrice = roundToCents(subscriptionRaw);

      // ✅ FREE SHIPPING TEXT (based on selected purchase type)
      const currentTotal =
        state.purchaseType === 'subscription' ? subscriptionPrice : oneTimePrice;
      updateFreeShippingText(summary, currentTotal);

      /* SUMMARY PRICE */
      summary.querySelectorAll('.js-compare-price').forEach(el => {
        if (state.purchaseType === 'subscription') {
          el.textContent = formatMoney(oneTimePrice);
          el.style.display = 'inline';
        } else {
          el.style.display = 'none';
        }
      });

      summary.querySelectorAll('.js-final-price').forEach(el => {
        el.textContent =
          state.purchaseType === 'subscription'
            ? formatMoney(subscriptionPrice)
            : formatMoney(oneTimePrice);
      });

      /* PURCHASE CARDS */
      document
        .querySelectorAll('.byo-purchase-card[data-value="subscription"]')
        .forEach(card => {
          const compare = card.querySelector('.js-compare-price');
          const final = card.querySelector('.js-final-price');
          if (compare) compare.textContent = formatMoney(oneTimePrice);
          if (final) final.textContent = formatMoney(subscriptionPrice);
        });

      document
        .querySelectorAll('.byo-purchase-card[data-value="onetime"]')
        .forEach(card => {
          const final = card.querySelector('.js-final-price');
          if (final) final.textContent = formatMoney(oneTimePrice);
        });
    });
  }

  /* =================================================
     CHECKOUT
  ================================================= */
  function handleCheckout() {
    const qty = state.items.length;
    if (!VALID_TIERS.includes(qty)) return;

    const items = state.items.map(item => {
      const obj = { id: item.id, quantity: 1 };
      if (state.purchaseType === 'subscription' && item.sellingPlan) {
        obj.selling_plan = item.sellingPlan;
      }
      return obj;
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items })
    }).then(() => {
      window.location.href = '/checkout';
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();